module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAMAAAD+zz7+AAAAJ1BMVEVMaXE/Pz89PT08PDw9PT0/Pz89PT08PDw8PDw9PT09PT09PT09PT3dAI88AAAADHRSTlMABKuQcAzCes/fo7coAyFRAAAAPElEQVR42j3KWQ4AIAgDUVAEl97/vKaK9mfykspZ672xKQf8Wx1mWJoqMBFD0VSwQVP1vio9qecpg3oeG0s3ATxni/44AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/103.png
// module id = dNf4
// module chunks = 73